"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_i18n_1 = require("@snapchat/web-i18n");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const messageLoader_1 = require("../../../i18n/messageLoader");
const PlayerModal_1 = require("../PlayerModal");
const constants_1 = require("./constants");
const ReportModalContent_1 = require("./ReportModalContent");
const web_env_1 = require("@snapchat/web-env");
/**
 * Report modal for snap content
 */
function ReportModal({ isVisible, onSubmit, onModalClose, isMobile, playNext, locale, }) {
    const [resolvedLocale] = (0, react_1.useState)((0, web_i18n_1.getLocale)(locale));
    const [messages, setMessages] = (0, react_1.useState)({});
    const [categories, setCategories] = (0, react_1.useState)(constants_1.DEFAULT_CATEGORIES);
    const [selectedCategory, setSelectedCategory] = (0, react_1.useState)();
    const [reportDescription, setReportDescription] = (0, react_1.useState)();
    const [withBackButton, setWithBackButton] = (0, react_1.useState)(false);
    const [withDescriptionField, setWithDescriptionField] = (0, react_1.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, react_1.useState)(false);
    const timerRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        setCategories(constants_1.DEFAULT_CATEGORIES);
        let isSubscribed = true;
        void (0, messageLoader_1.loadMessages)(resolvedLocale).then((messages) => {
            if (isSubscribed) {
                setMessages(messages);
            }
        });
        return function cleanup() {
            isSubscribed = false;
        };
    }, [resolvedLocale]);
    const onBackButtonClick = (0, react_1.useCallback)(() => {
        // TODO: these settings are made with the assumption that there is only one level of nested reporting.
        // To support more layers, the modal needs to detect if it's at the root layer and set these values to false.
        setWithBackButton(false);
        setReportDescription(""); // Erase report description if there was one
        setCategories(constants_1.DEFAULT_CATEGORIES);
    }, [setWithBackButton, setReportDescription, setCategories]);
    const onCategoryClick = (0, react_1.useCallback)((id) => {
        // If a category has a custom link, open that.
        const category = categories.get(id);
        if (category?.reportLink) {
            (0, web_env_1.getWindow)()?.open(category.reportLink);
            return;
        }
        const subCategory = category?.subCategory;
        if (subCategory) {
            setCategories(subCategory);
            setWithBackButton(true);
            setReportDescription("");
        }
        else {
            setSelectedCategory(id);
            setWithDescriptionField(true);
        }
    }, [categories]);
    const onReportDescriptionChange = (0, react_1.useCallback)((description) => {
        setReportDescription(description);
    }, [setReportDescription]);
    const onModalRefresh = (0, react_1.useCallback)(() => {
        setSelectedCategory(undefined);
        setWithBackButton(false);
        setWithDescriptionField(false);
        setReportDescription("");
        setCategories(constants_1.DEFAULT_CATEGORIES);
    }, []);
    const onReportSubmitted = (0, react_1.useCallback)(() => {
        setHasSubmitted(false);
        onModalClose();
        onModalRefresh();
        playNext?.();
    }, [onModalClose, onModalRefresh, playNext]);
    const onModalSubmit = (0, react_1.useCallback)(() => {
        if (!selectedCategory) {
            onModalRefresh();
            return;
        }
        onSubmit({
            id: selectedCategory,
            reportDescription,
        });
        setHasSubmitted(true);
        timerRef.current = (0, web_env_1.getWindow)()?.setTimeout(() => {
            onReportSubmitted();
        }, constants_1.DELAY_AFTER_SUBMIT);
    }, [selectedCategory, onSubmit, reportDescription, onModalRefresh, onReportSubmitted]);
    const onModalCancel = (0, react_1.useCallback)(() => {
        onModalRefresh();
        onModalClose();
    }, [onModalRefresh, onModalClose]);
    const onUserModalCancel = (0, react_1.useCallback)(() => {
        clearTimeout(timerRef.current);
        onReportSubmitted();
    }, [onReportSubmitted]);
    const modalContent = ((0, jsx_runtime_1.jsx)(ReportModalContent_1.ReportModalContent, { reportCategories: categories, withBackButton: withBackButton, withDescriptionField: withDescriptionField, onBackButtonClick: onBackButtonClick, onCategoryClick: onCategoryClick, onReportDescriptionChange: onReportDescriptionChange, textFieldTitle: constants_1.TEXTFIELD_TITLE, textFieldDescription: reportDescription, selectedCategory: selectedCategory, isMobile: isMobile, hasSubmitted: hasSubmitted }));
    return ((0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, { locale: resolvedLocale, defaultLocale: web_i18n_1.DEFAULT_LOCALE, messages: messages, children: (0, jsx_runtime_1.jsx)(PlayerModal_1.PlayerModal, { title: hasSubmitted ? constants_1.REPORT_SUBMITTED_HEADER : constants_1.REPORT_SNAP, modalContent: modalContent, primaryButtonLabel: hasSubmitted ? constants_1.CLOSE_BUTTON : selectedCategory ? constants_1.SUBMIT_BUTTON : null, secondaryButtonLabel: !hasSubmitted ? constants_1.CANCEL_BUTTON : null, onPrimaryButtonClick: hasSubmitted ? onUserModalCancel : onModalSubmit, onSecondaryButtonClick: onModalCancel, isVisible: isVisible }) }));
}
exports.ReportModal = ReportModal;
//# sourceMappingURL=ReportModal.js.map